import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { HemsSelectors } from '@store';

import { HemsActions } from './hems.actions';

@Injectable({ providedIn: 'root' })
export class HemsStore {
  constructor(private store: Store) {}

  hemsGatewaySerialIfNoError$: Observable<string> = this.store.select(
    HemsSelectors.selectHemsGatewaySerialIfNoError
  );

  setHemsGatewaySerial(gatewaySerial: string): void {
    this.store.dispatch(HemsActions.setHemsGatewaySerial({ gatewaySerial }));
  }
}
